export default "__VITE_ASSET__7WCDzvuU__"